module.exports = __webpack_public_path__ + "img/FPT04.c639af41.svg";